<template>
    <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">

            <!-- Brand logo-->
            <b-link class="brand-logo">
                <b-img
                    fluid
                    :src="logoImg"
                    width="120"
                />
            </b-link>
            <!-- /Brand logo-->

            <!-- Left Text-->
            <b-col
                lg="7"
                class="d-none d-lg-flex align-items-center p-5"
            >
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <b-img
                        fluid
                        :src="imgUrl"
                        alt="Forgot password V2"
                    />
                </div>
            </b-col>
            <!-- /Left Text-->

            <!-- Forgot password-->
            <b-col
                lg="5"
                class="d-flex align-items-center auth-bg px-2 p-lg-5"
            >
                <div class="sk-picker">
                    <b-form-select
                        v-model="locale"
                        :options="cultures"
                        label="text"
                    />
                </div>
                <b-col
                    sm="8"
                    md="6"
                    lg="12"
                    class="px-xl-2 mx-auto"
                >
                    <b-card-title class="mb-1">
                        {{i18nT(`Did you forget something?`)}} 🤔
                    </b-card-title>
                    <b-card-text class="mb-2">
                        {{i18nT(`Enter your email and we'll send you instructions to reset your password.`)}}
                    </b-card-text>

                    <!-- form -->
                    <validation-observer ref="simpleRules">
                        <b-form
                            class="auth-forgot-password-form mt-2"
                            @submit.prevent="validationForm"
                        >
                            <b-form-group
                                :label="i18nT(`Email`)"
                                label-for="forgot-password-email"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    name="Email"
                                    rules="required|email"
                                >
                                    <b-form-input
                                        id="forgot-password-email"
                                        v-model="userEmail"
                                        :state="errors.length > 0 ? false:null"
                                        name="forgot-password-email"
                                        placeholder="workemail@company.com"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <b-button
                                type="submit"
                                variant="primary"
                                block
                            >
                                {{i18nT(`Send reset link`)}}
                            </b-button>
                        </b-form>
                    </validation-observer>

                    <p class="text-center mt-2">
                        <b-link :to="{name:'auth-login', query: {lang: locale} }">
                            <feather-icon icon="ChevronLeftIcon" /> {{i18nT(`Back to login`)}}
                        </b-link>
                    </p>
                </b-col>
            </b-col>
            <!-- /Forgot password-->
        </b-row>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow,
    BCol,
    BLink,
    BCardTitle,
    BCardText,
    BImg,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import {dictToSelectArray} from "@core/utils/utils";

export default {
    components: {
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BCardTitle,
        BCardText,
        ValidationProvider,
        ValidationObserver
    },
    created() {
        this.getCultures()
    },
    data() {
        return {
            locale: 'en',
            cultures: [],
            userEmail: '',
            sideImg: require('@/assets/images/pages/register.svg'),
            logoImg: require('@/assets/images/logo/logo_color.svg'),
            // validation
            required,
            email
        }
    },
    computed: {
        imgUrl() {
            if (store.state.appConfig.layout.skin === 'dark') {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
                return this.sideImg
            }
            return this.sideImg
        }
    },
    methods: {
        getCultures() {
            this.$http.get(`system/cultures`).then(({data}) => {
                //console.log("Cultures:", data.data)
                this.cultures = dictToSelectArray(data.data)
                if(this.$route.query.lang) {
                    this.locale = this.$route.query.lang;
                }
            })
        },
        validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const formData = new FormData()

                    formData.append('email', this.userEmail)

                    this.$http
                        .post(`users/publicForgottenPassword`, formData)
                        .then(res => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: this.successMessage(res),
                                    icon: 'InfoIcon',
                                    variant: 'success'
                                }
                            })
                            router.push({ name: 'auth-login' })

                        })
                        .catch(err => {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-right',
                                props: {
                                    title: this.errorMessage(err),
                                    icon: 'InfoIcon',
                                    variant: 'danger'
                                }
                            })
                        })
                }
            })
        }
    },
    watch: {
        locale (val) {
            this.changeLang(val)
            history.pushState({}, null, `${this.$route.path}?lang=${val}`)
        },
    }
}
</script>

<style scoped>
.sk-picker {
    width: 150px;
    position: absolute;
    top: 20px;
    right: 20px;
}
</style>


<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
